import {inlineError} from '@s-ui/decorators'
import {Service} from '@s-ui/domain'

/**
 * @implements Service
 */
export class GetSubscriptionCommitmentOptionsAdsService extends Service {
  /**
   * @constructor
   * @param {Object} deps
   * @param {HTTPAdsRepository} deps.httpAdsRepository
   */
  constructor({httpAdsRepository}) {
    super()
    this._httpAdsRepository = httpAdsRepository
  }

  @inlineError
  async execute() {
    const [getSubscriptionCommitmentOptionsError, getSubscriptionCommitmentOptionsResponse] =
      await this._httpAdsRepository.getSubscriptionCommitmentOptions()
    return getSubscriptionCommitmentOptionsError
      ? Promise.reject(getSubscriptionCommitmentOptionsError)
      : getSubscriptionCommitmentOptionsResponse
  }
}
